//Bundled into main.min.js (imported by main.js for its side effect). The Google Maps API is
//NOT loaded from a <script> tag in the HTML: loadGoogleMapsApi() at the bottom of this file
//injects it only on pages that actually render a map (#map or #map_details), so every other
//page skips ~400KB / 9 requests. The API key comes from window.googleMapsApiKey, set inline in
//includes/scripts.html so each environment can switch keys without touching the bundle.
//Google Maps calls this global callback once the API is ready. Wrapped in DOM ready so the
//#map check below is reliable no matter which finishes first.
window.initLocatorMap = function() { $(function() {

    /*
    GET /api/locations — query params
    latitude     (required)  number, -90 to 90
    longitude    (required)  number, -180 to 180
    searchRadius (required)  number, > 0 and ≤ 50
    placeType    (optional)  repeat the param for multiple values
                             e.g. ?placeType=Branch&placeType=LMCU-ATM

    placeType allowed values (case-insensitive):
      Branch, LMCU-ATM, AllPoint-ATM
      • omit it entirely → defaults to Branch
      • any unknown value (even mixed with valid ones) → 400, nothing returned

    :warning: The param is placeType (singular), repeated — NOT placeTypes.
      Sending the old ?placeTypes=... binds to nothing and silently
      falls back to Branch (wrong results, no error).

    Validation failures return HTTP 400 with:
      { "error": "<message>" }
      e.g. searchRadius=51 → { "error": "searchRadius exceeds maximum of 50" }
           placeType=Kiosk → { "error": "unknown placeType 'Kiosk'" }

    Example:
      /api/locations?latitude=42.32&longitude=-85.18&searchRadius=50&placeType=lmcu-atm&placeType=branch
      https://lmcu01mstr8x42cinte.dxcloud.episerver.net/api/locations?latitude=42.32&longitude=-85.18&searchRadius=50&placeType=branch

    Open/Closed status timezone:
      Each result MAY include an IANA "timezone" field (e.g. "America/Chicago");
      it is honored per location when computing open/closed status.
      Locations without one fall back to America/Detroit (Eastern) - correct for
      all Michigan and southwest Florida locations. The field only becomes
      required if a location outside Eastern Time is ever added
      (e.g. the Florida Panhandle is Central).
*/

    //Branch Details Map - single pin, centered on the branch coordinates
    //held in the #branchLat / #branchLong hidden fields
    if( $('#map_details').length ) {

        (function() {
            //Global Variables
            var iconURL = '/assets/images/locator/',
                branchLat = parseFloat($('#branchLat').val()),
                branchLong = parseFloat($('#branchLong').val()),
                latLng,
                branchpin,
                extmap;

            //No usable coordinates - leave the map container empty rather than
            //dropping a pin in the middle of the ocean
            if( isNaN(branchLat) || isNaN(branchLong) ) {
                return;
            }

            latLng = new google.maps.LatLng(branchLat, branchLong);

            //Branch Location Pin
            function branchPin(latLng) {
                branchpin = new google.maps.Marker({
                    position: latLng,
                    icon: iconURL + 'pin-lmcu-branches.svg',
                    map: extmap,
                    animation: google.maps.Animation.DROP,
                    id: 'branch',
                    clickable: false
                });
            }

            //Google Init Map
            function initMap() {
                // Set map options
                var mapOptions = {
                    zoom: 14,
                    center: latLng,
                    disableDefaultUI: true,
                    zoomControl: true,
                    panControl: true,
                    streetViewControl: false,
                    rotateControl: true
                };

                // Create the map
                extmap = new google.maps.Map(document.getElementById('map_details'), mapOptions);

                //Branch Location
                branchPin(latLng);

                //WCGA Map Updates
                google.maps.event.addListenerOnce(extmap, 'tilesloaded', function() {
                    $('#map_details').find('[aria-label="Map"]').attr('aria-label', 'Map of this branch location');
                    $('#map_details').find('iframe').attr('title', 'Google Interactive Map');
                });
            }
            initMap();
        })();

    }

    //Locations Map
    if( $('#map').length ) {

        $(function() {
            //Global Variables
            //CMS-owned config. The BranchLocatorPage view puts the editor's Default latitude /
            //Default longitude on #map as data attributes; the fallbacks keep this file working
            //standalone if an attribute is ever missing (or the FE template is used outside the CMS).
            var mapEl = document.getElementById('map'),
                cfg = (mapEl && mapEl.dataset) || {},
                numberOr = function(value, fallback) {
                    var parsed = parseFloat(value);
                    return isFinite(parsed) ? parsed : fallback;
                },
                //API_URL = 'https://lmcu01mstr8x42cinte.dxcloud.episerver.net/api/locations?',
                API_URL = '/api/locations?',
                extmap,
                latLng,
                userpin,
                lat = numberOr(cfg.defaultLatitude, 42.9567974), //Default - Grand Rapids, MI
                long = numberOr(cfg.defaultLongitude, -85.701448), //Default
                mapCenterLat = lat,
                mapCenterLng = long,
                markers = [],
                bounds,
                hours,
                setHours,
                geocoder,

                iconURL = '/assets/images/locator/',
                defaultTimezone = 'America/Detroit', //All LMCU locations are in Michigan (Eastern Time)
                category = 'branch', //placeType filter: branch, lmcu-atm, allpoint-atm
                iconType = iconURL + 'pin-lmcu-branches.svg', //Default
                typeLabels = {
                    'branch': 'LMCU Branch',
                    'lmcu-atm': 'LMCU ATM',
                    'allpoint-atm': 'AllPoint ATM'
                },
                featureLabels = {
                    'hasFullServiceLobby': 'Full Service Lobby',
                    'hasDriveThruServices': 'Drive-Thru Services',
                    'hasSafeDepositBoxes': 'Safe Deposit Boxes',
                    'hasMedallionSignatureGuarantee': 'Medallion Signature Guarantee',
                    'hasNotaryPublic': 'Notary Public',
                    'has24HourDriveUpAtm': '24-Hour Drive-Up ATM',
                    'has24HourNightDeposit': '24-Hour Night Deposit',
                    'hasMortgageServices': 'Mortgage Services',
                },
                //Services dropdown placeholder per location type
                servicesPlaceholderByType = {
                    'branch': 'Select Branch Services',
                    'lmcu-atm': 'Select ATM Services',
                    'allpoint-atm': 'Select AllPoint ATM Services'
                },
                //Services filter per location type: dropdown option -> feature flag in the API data
                servicesByType = {
                    'branch': [
                        { value: 'full-service-lobby', label: 'Full Service Lobby', feature: 'hasFullServiceLobby' },
                        { value: 'notary-public', label: 'Notary Public', feature: 'hasNotaryPublic' },
                        { value: '24-hour-drive-up-atm', label: '24-Hour Drive-Up ATM', feature: 'has24HourDriveUpAtm' },
                        { value: '24-hour-night-deposit', label: '24-Hour Night Deposit', feature: 'has24HourNightDeposit' },
                        { value: 'drive-thru-services', label: 'Drive-Thru Services', feature: 'hasDriveThruServices' },
                        { value: 'mortgage-services', label: 'Mortgage Services', feature: 'hasMortgageServices' },
                        { value: 'medallion-signature-guarantee', label: 'Medallion Signature Guarantee', feature: 'hasMedallionSignatureGuarantee' },
                        { value: 'safe-deposit-boxes', label: 'Safe Deposit Boxes', feature: 'hasSafeDepositBoxes' }
                    ],
                    'lmcu-atm': [
                        { value: 'located-at-branch', label: 'Located at Branch', feature: 'isAtBranch' },
                        { value: 'drive-up', label: 'Drive Up', feature: 'isDriveUp' },
                        //{ value: 'intelligent-deposit', label: 'Intelligent Deposit', feature: 'hasIntelligentDeposit' },
                        { value: 'itm-available', label: 'Live Teller Assistance', feature: 'isItmAvailable' },
                        { value: 'open-24-hours', label: 'Open 24 Hours', feature: 'isOpen24Hours' },
                        { value: 'surcharge-free', label: 'Surcharge Free', feature: 'isSurchargeFree' },
                        //{ value: 'wheelchair-accessible', label: 'Wheelchair Accessible', feature: 'isWheelchairAccessible' },
                        { value: 'cash-deposit', label: 'Cash Deposit', feature: 'supportsCashDeposit' },
                        { value: 'cash-withdrawal', label: 'Cash Withdrawal', feature: 'supportsCashWithdrawal' },
                        { value: 'check-deposit', label: 'Check Deposit', feature: 'supportsCheckDeposit' },
                        //{ value: 'audio-guidance', label: 'Audio Guidance', feature: 'isAudioGuidance' },
                        //{ value: 'braille-keypad', label: 'Braille Keypad', feature: 'isBrailleKeypad' }
                    ],
                    'allpoint-atm': [
                        { value: 'surcharge-free', label: 'Surcharge Free', feature: 'isSurchargeFree' },
                        { value: 'cash-withdrawal', label: 'Cash Withdrawal', feature: 'supportsCashWithdrawal' },
                    ]
                },
                lastResults = [], //Cached API results, re-filterable without a new request
                isLoading = false, //True while a locations request is in flight
                suppressServicesChange = false, //Skip re-render on programmatic dropdown resets

                infoWindow = new google.maps.InfoWindow();

            //Browser GeoLocation on Page Load
            function onPositionReceived(position) {
                lat = position.coords['latitude'];
                long = position.coords['longitude'];

                //Center the map on the user and refresh the results
                updateUserLocation(new google.maps.LatLng(lat,long));
            }

            //Autocomplete location - PlaceAutocompleteElement (Places API New).
            //The legacy places.Autocomplete widget can't be enabled on newer
            //Google Cloud projects (LegacyApiNotActivatedMapError), so the static
            //input is swapped for the web component. Its real input lives in a
            //closed shadow DOM - styled via ::part(input) in the CSS, read via
            //the element's .value property.
            var placeAutocomplete = new google.maps.places.PlaceAutocompleteElement({
                includedRegionCodes: ['us'] //All LMCU locations are in the US
            });
            placeAutocomplete.id = 'enterCurrentLoc';
            placeAutocomplete.placeholder = 'Enter a City, State or ZIP Code';
            placeAutocomplete.noInputIcon = true; //The block supplies its own search button
            placeAutocomplete.noClearButton = true;
            document.getElementById('enterCurrentLoc').replaceWith(placeAutocomplete);

            //True when gmp-select handled the current Enter press, so the
            //raw-text geocode fallback below stays quiet
            var suggestionSelected = false;

            //State-level searches ("Michigan", "FL", "Florida, USA") would land
            //on the state's geographic center - mid-Lower-Peninsula and central
            //Florida - where there are no branches. Recenter those on the
            //nearest LMCU hub instead. Keyed by the state's short code; city
            //and ZIP searches inside these states are left alone.
            var stateOverrides = {
                MI: { lat: 42.9634, lng: -85.6681 }, //Grand Rapids
                FL: { lat: 27.9506, lng: -82.4572 }  //Tampa
            };

            //Returns the override LatLng when the resolved place is a US state
            //with an entry in stateOverrides, otherwise null. Works off what
            //Google resolved (types + address components) rather than the
            //typed text, so every spelling of the state is caught and a street
            //named "Michigan Ave" is not. `types` is the place's type list;
            //`components` is an array of { types, shortText } - the normalized
            //shape shared by the Geocoder and Place APIs (see normalizeComponents).
            function stateOverride(types, components) {
                if( !types || types.indexOf('administrative_area_level_1') === -1 ) {
                    return null;
                }
                var state = (components || []).filter(function(c) {
                    return c.types.indexOf('administrative_area_level_1') !== -1;
                })[0];
                var override = state && stateOverrides[state.shortText];
                return override ? new google.maps.LatLng(override.lat, override.lng) : null;
            }

            //Geocoder results use { types, short_name }; Place.addressComponents
            //use { types, shortText }. Map both onto the shortText form.
            function normalizeComponents(components) {
                return (components || []).map(function(c) {
                    return { types: c.types || [], shortText: c.shortText || c.short_name };
                });
            }

            //User selected an address from the Autocomplete dropdown
            placeAutocomplete.addEventListener('gmp-select', function(event) {
                suggestionSelected = true;
                var place = event.placePrediction.toPlace();
                place.fetchFields({ fields: ['location', 'types', 'addressComponents'] }).then(function() {
                    var latLng = stateOverride(place.types, normalizeComponents(place.addressComponents));
                    if( !latLng && place.location ) {
                        latLng = new google.maps.LatLng(place.location.lat(), place.location.lng());
                    }
                    if( latLng ) {
                        lat = latLng.lat();
                        long = latLng.lng();
                        updateUserLocation(latLng);
                    }
                });
            });

            //Recenter on a new user location and refresh markers + list
            function updateUserLocation(latLng) {
                //Center Map to New Location
                extmap.setCenter(latLng);
                //Update User Location Pin
                userPin(latLng);
                //Map Bounds & Center
                userLocMapBounds(extmap);
                //Delete all markers
                deleteMarkers();
                //Get Data
                getData();
            }

            //Map Bounds
            function userLocMapBounds(extmap) {
                //Map Bounds
                bounds =  extmap.getBounds();

                //Map Center
                mapCenterLat = extmap.getCenter().lat();
                mapCenterLng = extmap.getCenter().lng();
            }

            //Init Google Map
            function initMap(latLng) {
                geocoder = new google.maps.Geocoder();

                // Set map options
                var mapOptions = {
                    zoom: 11,
                    center: {
                        lat: lat,
                        lng: long
                    },
                    disableDefaultUI: true,
                    zoomControl: false,
                    panControl: false,
                    cameraControl: true,
                    streetViewControl: false,
                    rotateControl: true
                };

                // Create the map
                extmap = new google.maps.Map(document.getElementById('map'), mapOptions);

                //User Location
                userPin(latLng);

                //Locations Data
                getData();

                //Panning map bounds
                //mapBounds();

                //WCGA Map Updates
                google.maps.event.addListenerOnce(extmap, 'tilesloaded', function(){
                    setTimeout(function(){
                    $('.gm-style > div').removeAttr('tabindex');
                    }, 2000);
                    $('.gm-style').find('iframe').attr('title', 'Google Interactive Map');
                });
            }
            initMap();

            // Check to see if the browser supports the GeoLocation API.
            if (navigator.geolocation) {
                // Get user location - the browser shows its share-location prompt
                navigator.geolocation.getCurrentPosition(onPositionReceived, function() {
                    //Denied or unavailable - keep the default map center, results already loaded
                });
            }

            //User Location Pin - created on first position, moved on later updates
            function userPin(latLng) {
                if( !latLng ) {
                    return;
                }

                if( userpin ) {
                    userpin.setPosition(latLng);
                    return;
                }

                //Place marker at user location
                userpin = new google.maps.Marker({
                    position: latLng,
                    icon: iconURL + "pin-user.svg", //Placeholder - swap for the final user pin asset
                    map: extmap,
                    animation: google.maps.Animation.DROP,
                    id: 'geolocation',
                    zIndex: 999 //Keep the user pin above location markers
                });
            }

            //Get Map Bounds on Drag
            function mapBounds() {
                //Find the new map bounds only when panning / zooming stopped
                google.maps.event.addListener(extmap, 'dragend', function () {
                    //Map Bounds & Center
                    userLocMapBounds(extmap);

                    //Delete all markers
                    deleteMarkers();

                    //Get new data
                    getData();
                });
            }

            //Get Data
            function getData() {
                $.ajax({
                    url: API_URL + 'latitude=' + mapCenterLat + '&longitude=' + mapCenterLng + '&searchRadius=50&placeType=' + category,
                    type: 'GET',
                    dataType: 'json',
                    beforeSend: function () {
                        isLoading = true;
                        $('#map_loader').fadeIn();
                    },
                    success: function(data) {
                        //Keep the results so filters can re-render without another API call
                        lastResults = data.results || [];
                        isLoading = false;

                        console.log(data);

                        renderResults();

                        //Map Bounds & Center
                        userLocMapBounds(extmap);

                        //Hide Loader
                        $('#map_loader').fadeOut();
                    },
                    error: function() {
                        isLoading = false;
                        $('#map_loader').fadeOut();
                        $('#map_error').addClass('active').fadeIn();
                    }
                });
            }

            //Feature keys required by the currently selected services
            function selectedServices() {
                var el = document.getElementById('loc-services'),
                    services = servicesByType[category] || [];

                if( !el || !services.length ) {
                    return [];
                }

                var featureByValue = {};
                $.each(services, function(i, service) {
                    featureByValue[service.value] = service.feature;
                });

                var keys = [];
                $.each(el.values || [], function(i, value) {
                    if( featureByValue[value] ) {
                        keys.push(featureByValue[value]);
                    }
                });
                return keys;
            }

            //Swap the services dropdown options for the current location type
            //(hidden when the type has no services list)
            function renderServicesOptions() {
                var el = document.getElementById('loc-services');
                if( !el ) {
                    return;
                }

                var services = servicesByType[category] || [];

                $(el).closest('.locations-services').toggle(services.length > 0);

                el.setAttribute('placeholder', servicesPlaceholderByType[category] || 'Choose services...');

                var html = '';
                $.each(services, function(i, service) {
                    html += '<option value="' + service.value + '">' + service.label + '</option>';
                });
                el.innerHTML = html;

                //Clear any selection from the previous type without triggering
                //a re-render - the type switch is about to fetch fresh data anyway
                suppressServicesChange = true;
                el.values = [];
                suppressServicesChange = false;
            }

            //Render the cached results into the map + HTML list,
            //applying the location type and services filters
            function renderResults() {
                //Clear the map and the list, and set the type class
                //so the list pins match the map pins
                deleteMarkers();
                $("#locations_list").empty()
                    .removeClass('type-branch type-lmcu-atm type-allpoint-atm')
                    .addClass('type-' + category);

                var services = selectedServices();

                var num = 0;
                $.each(lastResults, function(i, item) {
                    if( !item.placeType || item.placeType.toLowerCase() != category ) {
                        return;
                    }

                    //Location must offer every selected service
                    var matches = true;
                    $.each(services, function(j, key) {
                        if( !item.features || item.features[key] !== true ) {
                            matches = false;
                            return false;
                        }
                    });
                    if( !matches ) {
                        return;
                    }

                    num++;
                    //Add Markers to Map
                    addMarker(item, num);
                    //Add Locations to HTML List
                    addLocationList(item, num);
                });

                //Check if we have results first
                //Only shown once data has arrived - while a request is in
                //flight the loader is visible instead, so no flash on type switches
                if( num === 0 && !isLoading ) { //if there is no data
                    //Setup side HTML
                    var locationList = `
                        <li class="no-border">
                            <div class="loc loc-error">
                                <p><strong>No results found for your search.</strong></p>
                                <p>Adjust filters or change your search area.</p>
                            </div>
                        </li>
                    `;
                    $("#locations_list").append(locationList);
                }
            }

            //Filter the current results when services are selected - no new API call
            $(document).on('change', '#loc-services', function() {
                if( suppressServicesChange ) {
                    return;
                }
                renderResults();
            });

            //Format "17:30" as "5:30 PM"
            function formatTime(time) {
                var parts = time.split(':'),
                    hour = parseInt(parts[0], 10),
                    mins = parts[1],
                    period = hour >= 12 ? 'PM' : 'AM';

                hour = hour % 12 || 12;

                return hour + ':' + mins + ' ' + period;
            }

            //Current day + time-of-day in a specific IANA timezone
            function nowInTimezone(timezone) {
                var dayIndex = { 'Sun': 0, 'Mon': 1, 'Tue': 2, 'Wed': 3, 'Thu': 4, 'Fri': 5, 'Sat': 6 },
                    parts = new Intl.DateTimeFormat('en-US', {
                        timeZone: timezone,
                        weekday: 'short',
                        hour: 'numeric',
                        minute: 'numeric',
                        hourCycle: 'h23'
                    }).formatToParts(new Date()),
                    out = {};

                $.each(parts, function(i, p) {
                    out[p.type] = p.value;
                });

                return {
                    day: dayIndex[out.weekday],
                    mins: parseInt(out.hour, 10) * 60 + parseInt(out.minute, 10)
                };
            }

            //Open / Closed status from a location's hours, in the location's timezone
            //API dayOfWeek: 1 = Monday ... 6 = Saturday (matches JS getDay(); Sunday has no entry)
            function getLocStatus(locHours, timezone) {
                if( !locHours || !locHours.length ) {
                    return null;
                }

                var now = nowInTimezone(timezone || defaultTimezone),
                    day = now.day,
                    nowMins = now.mins;

                function toMins(time) {
                    var parts = time.split(':');
                    return parseInt(parts[0], 10) * 60 + parseInt(parts[1], 10);
                }

                function findDay(d) {
                    var match = null;
                    $.each(locHours, function(i, h) {
                        if( h.dayOfWeek == d ) {
                            match = h;
                        }
                    });
                    return match;
                }

                var today = findDay(day);
                if( today ) {
                    if( nowMins < toMins(today.open) ) {
                        return { open: false, text: 'Closed. Opens at ' + formatTime(today.open) + '.' };
                    }
                    if( nowMins < toMins(today.close) ) {
                        return { open: true, text: 'Open. Closes at ' + formatTime(today.close) + '.' };
                    }
                }

                //Closed now - find the next day with hours
                for( var i = 1; i <= 7; i++ ) {
                    var next = findDay((day + i) % 7);
                    if( next ) {
                        return { open: false, text: 'Closed. Opens ' + next.dayName + ' at ' + formatTime(next.open) + '.' };
                    }
                }

                return null;
            }

            //Features object of boolean flags -> array of readable labels for the true ones
            function getLocFeatures(features) {
                var list = [];
                $.each(features || {}, function(key, val) {
                    if( val === true ) {
                        list.push(featureLabels[key] || key);
                    }
                });
                return list;
            }

            //Add Location to HTML List
            function addLocationList(item, num) {
                var addr = item.address,
                    status = getLocStatus(item.hours, item.timezone),
                    locType = typeLabels[item.placeType.toLowerCase()] || item.placeType,
                    directionsURL = 'https://www.google.com/maps/dir/?api=1&destination=' + addr.latitude + ',' + addr.longitude,
                    features = getLocFeatures(item.features),
                    apptLink = '';

                $.each(item.appointmentLinks || [], function(i, link) {
                    if( link.type == 'SCHEDULE_APPOINTMENT' ) {
                        apptLink = '<a href="' + link.url + '" class="btn btn-secondary-inverted">Meet with Us</a>';
                    }
                });

                var html =
                    '<li id="' + item.id + '">' +
                        '<div class="loc info-' + item.id + '">' +
                            '<div class="loc_pin">' +
                                '<div class="pin">' + num + '</div>' +
                            '</div>' +
                            '<div class="loc_header">' +
                                '<h3 class="loc_name">' + item.name + '</h3>' +
                                '<div class="loc_type">' + locType + '</div>' +
                                '<div class="loc_address">' +
                                    addr.street + ',<br>' +
                                    addr.city + ', ' + addr.state + ' ' + addr.postalCode +
                                '</div>' +
                                (status ? '<div class="loc_status ' + (status.open ? 'status-open' : 'status-closed') + '">' + status.text + '</div>' : '') +
                                (item.alert ?
                                '<div class="loc_alert">' +
                                    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">' +
                                        '<path d="M11.1543 2.46582C11.5303 1.81454 12.4697 1.81454 12.8457 2.46582L20.6807 16.0342C21.0567 16.6855 20.586 17.5 19.834 17.5H4.16602C3.41398 17.5 2.94332 16.6855 3.31934 16.0342L11.1543 2.46582Z" stroke="#B94700"/>' +
                                        '<path d="M12.002 6.5L12.0014 12.2382" stroke="#B94700" stroke-width="1.10769" stroke-linecap="round"/>' +
                                        '<circle cx="11.9992" cy="14.9543" r="0.923077" fill="#B94700"/>' +
                                    '</svg>' +
                                    '<span>' + item.alert + '</span>' +
                                '</div>' : '') +
                                '<div class="loc_distance">' + item.distance.value.toFixed(1) + ' mi</div>' +
                            '</div>' +
                        '</div>' +
                        '<div class="loc_footer">' +
                            apptLink +
                            '<a href="' + directionsURL + '" target="_blank" rel="noopener">Get Directions ></a>' +
                            (item.url ? '<a href="' + item.url + '">View Details ></a>' : '') +
                        '</div>' +
                    '</li>';

                $('#locations_list').append(html);
            }

            //Add Marker to Map
            function addMarker(item, num) {
                var addr = item.address;

                var marker = new google.maps.Marker({
                    position: { lat: addr.latitude, lng: addr.longitude },
                    icon: {
                        url: iconType,
                        labelOrigin: new google.maps.Point(16, 16) //Center of the 32x40 pin head
                    },
                    label: {
                        text: String(num),
                        color: '#FFFFFF',
                        fontSize: '14px',
                        fontWeight: '700'
                    },
                    map: extmap,
                    id: item.id,
                    title: item.name
                });

                marker.addListener('click', function() {
                    var status = getLocStatus(item.hours, item.timezone),
                        features = getLocFeatures(item.features);

                    infoWindow.setContent(`
                        <div class="loc-infowindow">
                            <div class="loc-title">${item.name}</div>
                            <div class="loc-address">
                                ${addr.street},<br>
                                ${addr.city}, ${addr.state} ${addr.postalCode}
                            </div>
                            ${features.length ? `
                            <div class="loc-services">
                                <span>Services</span>
                                <ul>
                                    ${features.map(f => `<li>${f}</li>`).join('')}
                                </ul>
                            </div>` : ''}
                            <div class="loc-directions">
                                ${item.url ? `<a href="${item.url}">View Full Details ></a>` : ''}
                            </div>
                        </div>
                    `);
                    infoWindow.open(extmap, marker);

                    //Highlight the matching location in the HTML list
                    var $li = $('#locations_list li').removeClass('active')
                        .filter('#' + item.id).addClass('active');

                    //Scroll the list to the highlighted location if it is out of view
                    var locWrap = $li.closest('.map_locations')[0];
                    if( locWrap && $li.length ) {
                        var liTop = $li.position().top,
                            liBottom = liTop + $li.outerHeight();

                        if( liTop < locWrap.scrollTop || liBottom > locWrap.scrollTop + locWrap.clientHeight ) {
                            $(locWrap).animate({ scrollTop: liTop }, 300);
                        }
                    }
                });

                markers.push(marker);
            }

            //Entering Address in text field and updating user location
            $('#getLocation').on('click', function(e) {
                getLocation(e);
            });

            //Keydown events compose out of the widget's shadow DOM, but Enter
            //only fires gmp-select when a suggestion is highlighted - wait a
            //beat and geocode the raw text if no selection handled the press
            placeAutocomplete.addEventListener('keydown', function(e) {
                if( e.key === 'Enter' ) {
                    suggestionSelected = false;
                    setTimeout(function() {
                        if( !suggestionSelected ) {
                            getLocation(e);
                        }
                    }, 300);
                }
            });

            var getLocation = function(e) {
                var startingLocation = placeAutocomplete.value;
                if( startingLocation ==  '' ) {
                    $('#enterCurrentLoc-error').show();
                    e.preventDefault();
                } else {
                    $('#enterCurrentLoc-error').hide();
                    //Restricted to the US like the autocomplete widget - without it
                    //bare state abbreviations ("MI", "FL") return ZERO_RESULTS
                    geocoder.geocode( { 'address': startingLocation, componentRestrictions: { country: 'US' } }, function(results, status) {
                        if (status == 'OK') {
                            var result = results[0],
                                latLng = stateOverride(result.types, normalizeComponents(result.address_components))
                                    || result.geometry.location;
                            lat = latLng.lat();
                            long = latLng.lng();

                            updateUserLocation(latLng);
                        }
                    });
                };
            };

            //Filter Map and HTML List based on selected radio button
            var $radios = $('input[name=location-type]').change(function () {
                var value = $radios.filter(':checked').val();

                if( value == 'branch') {
                    iconType = iconURL + 'pin-lmcu-branches.svg';
                }else if( value == 'lmcu-atm' ) {
                    iconType = iconURL + 'pin-lmcu-atms.svg';
                }else if( value == 'allpoint-atm' ) {
                    iconType = iconURL + 'pin-allpoint-atms.svg';
                }
                category = value;

                //Swap the services list for the selected location type
                renderServicesOptions();

                //Delete all markers
                deleteMarkers();
                //Run the new Data
                getData();
            });

            //Open infowindow from matching HTML link
            var locInfo = $('#locations_list');
            $(locInfo).on('click', '> *', function() {

                // get link data-title
                var titleToFind = $(this).attr('id');
                // find map marker in markers array with the same title
                var markerToClick;
                $.each(markers, function(i, marker) {
                    if(marker.id == titleToFind) {
                        markerToClick = markers[i];
                    }
                });

                new google.maps.event.trigger( markerToClick, 'click' );
            });

            // Sets the map on all markers in the array.
            function setMapOnAll(map) {
                for (var i = 0; i < markers.length; i++) {
                    markers[i].setMap(extmap);
                }
            }

            // Removes the markers from the map, but keeps them in the array.
            function clearMarkers() {
                setMapOnAll(null);
            }

            // Deletes all markers in the array by removing references to them.
            function deleteMarkers(){
                for(var i=0; i<markers.length;i++){
                    markers[i].setMap(null);
                }
                markers = [];
            }

        });
    }
}); };

//Load the Google Maps API only when this page has a map to put it in.
(function loadGoogleMapsApi() {
    var hasMap = document.querySelector('#map, #map_details');
    if (!hasMap) return;

    if (window.google && window.google.maps && window.google.maps.Map) {
        window.initLocatorMap(); //API already on the page (e.g. injected by the CMS)
        return;
    }

    var key = window.googleMapsApiKey;
    if (!key) {
        console.warn('locator.js: window.googleMapsApiKey is not set, so the Google Maps API was not loaded (see includes/scripts.html).');
        return;
    }

    var script = document.createElement('script');
    script.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(key) +
        '&libraries=geometry,places&loading=async&callback=initLocatorMap';
    script.async = true;
    document.head.appendChild(script);
})();
